import { sanitizeInput } from "../../../utils/sanitization";

export const TEAM_NAME_MAX_LENGTH = 50;

export const TEAM_NAME_EMPTY_ERROR = "Enter a team name.";

export const TEAM_NAME_LENGTH_ERROR =
  "Team name must be 50 characters or fewer.";

export const TEAM_NAME_CHAR_ERROR =
  "Use letters, numbers, spaces, hyphens, apostrophes, periods, or underscores.";

const invalidTeamName = (message) =>
  Object.assign(new Error(message), { code: "INVALID_TEAM_NAME" });

const notSaved = () =>
  Object.assign(
    new Error(
      "Team name was not saved. Check that you can manage this tournament."
    ),
    { code: "TEAM_NAME_NOT_SAVED" }
  );

/** Empty, too long, or characters Create Team would strip. Whitespace is collapsed, not rejected. */
export const teamNameError = (value) => {
  const trimmed = String(value ?? "").trim();
  if (!trimmed) return TEAM_NAME_EMPTY_ERROR;
  if (trimmed.length > TEAM_NAME_MAX_LENGTH) return TEAM_NAME_LENGTH_ERROR;

  const sanitized = sanitizeInput(trimmed);
  const collapsed = trimmed.replace(/\s+/g, " ");
  if (!sanitized || sanitized !== collapsed) return TEAM_NAME_CHAR_ERROR;
  return null;
};

export const normalizedTeamName = (value) => {
  if (teamNameError(value)) return null;
  return sanitizeInput(value);
};

export const updateTeamName = async (client, teamId, rawName) => {
  const message = teamNameError(rawName);
  if (message) throw invalidTeamName(message);
  if (!teamId) throw notSaved();

  const teamName = normalizedTeamName(rawName);
  const { data, error } = await client
    .from("teams")
    .update({ teamName })
    .eq("id", teamId)
    .eq("isDeleted", false)
    .select("teamName")
    .maybeSingle();

  if (error) throw error;
  if (!data || data.teamName !== teamName) throw notSaved();
  return data.teamName;
};
